module.exports = __webpack_public_path__ + "img/eye-protect-system-black.cc10901b.svg";